  <script setup lang="ts">
  // 静态导入所有页脚图片资源
  import homeActive from '@/assets/images/footer/home_active.png'
  import homeNormal from '@/assets/images/footer/home_normal.png'
  import questionNormal from '@/assets/images/footer/question_normal.png'
  import questionActive from '@/assets/images/footer/question_active.png'

  import { RouterView } from 'vue-router'
  import { ref, watch, computed, provide, } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  const route = useRoute()
  const router = useRouter()
  const cachedComponents = ref<string[]>([])
  // 添加缓存
  const addCache = (componentName: string) => {
    if (!cachedComponents.value.includes(componentName)) {
      cachedComponents.value.push(componentName)
      console.log(`添加缓存: ${componentName}`, cachedComponents.value)
    }
  }
  // 移除缓存
  const removeCache = (componentName: string) => {
    const index = cachedComponents.value.indexOf(componentName)
    if (index > -1) {
      cachedComponents.value.splice(index, 1)
      console.log(`移除缓存: ${componentName}`, cachedComponents.value)
    }
  }
  // 暴露缓存方法
  provide('cacheControl', {
    addCache,
    removeCache,
    cachedComponents
  })
  // 定义图标配置（使用本地图片路径）
  const tabbarItems = [
    {
      name: '首页',
      icon: homeNormal,  // 使用普通状态图标
      activeIcon: homeActive, // 使用激活状态图标
      index: 0
    },
    {
      name: '个人中心',
      icon: questionNormal,
      activeIcon: questionActive,
      index: 1
    },
  ]
  const active = ref(0) // 默认选中首页
  const onTabChange = (index: number) => {
    const routes = ['/home', '/user']
    router.replace({
      path: routes[index],
    })
    active.value = index
  }
  const backTopProps = () => {
    const isMessage = localStorage.getItem('isMessage') || ''
    if (isMessage === '1') {
      localStorage.removeItem('isMessage')
      router.replace({ path: '/home' })
      return
    }
    window.history.back()
  }
  // 路由路径与标签索引的映射
  const getRouteIndex = (path: string): number => {
    if (path === '/home' || path === '/') return 0; // 只有 /home 和 / 时首页激活
    if (path === '/user') return 1; // 个人中心激活
    return -1; // 业务页面时无导航激活（全部置灰）
  };
  const showTabbarRoutes = ['/', '/home', '/user']; 
  const showBackButtonRoutes = ['/mini_app_repair']; 
  const isShowTabbar = computed(() => showTabbarRoutes.includes(route.path));
  const isShowBackButton = computed(
    () => !showTabbarRoutes.includes(route.path) && !showBackButtonRoutes.includes(route.path)
  );
  watch(() => route.path, (newPath) => {
    active.value = getRouteIndex(newPath); // 所有路径都能正确映射索引
  },{ immediate: true });

  </script>

  <template>
    <div class="app">
      <!-- 主要内容区域 -->
      <div :class="['main-content', isShowTabbar ? 'has-tabbar' : 'no-tabbar']">
        <RouterView />
        <!--
          <router-view v-slot="{ Component }">
            <keep-alive :include="cachedComponents" :max="10">
              <component 
                :is="Component" 
                v-if="route.meta.keepAlive"
                :key="route.fullPath"
              />
            </keep-alive>
            <component 
              :is="Component" 
              v-if="!route.meta.keepAlive"
              :key="route.fullPath"
            />
          </router-view>
        -->
      </div>
      <!-- 底部导航栏 -->
      <van-tabbar v-model="active" @change="onTabChange" fixed v-show="isShowTabbar">
        <van-tabbar-item 
          v-for="item in tabbarItems" 
          :key="item.index"
          :name="item.index"
        >
          <!-- 使用插槽自定义图标 -->
          <template #icon="{ active: isActive }">
            <!-- 使用预加载的图片URL -->
            <img 
              :src="item.icon" 
              :class="{'hidden-img': isActive, 'tabbar-icon': !isActive,}"
            />
            <img 
              :src="item.activeIcon" 
              :class="{'hidden-img': !isActive, 'tabbar-icon': isActive,}"
            />
          </template>
          <span>{{ item.name }}</span>
        </van-tabbar-item>
      </van-tabbar>
      <div class="back-button" @click="backTopProps()" v-show="isShowBackButton">
        <img src="@/assets/images/back.png" class="home-back-img"></img>
      </div>
    </div>
  </template>

  <style scoped lang="scss">
  .app {
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    background-color: #ffffff;
    position: relative;
  }
  .back-button {
    position: fixed;
    bottom: 22rem;
    left: 0px;
    z-index: 2005;
    .home-back-img {
      width: 5rem;
    }
  }
  .main-content {
    width: 100%;
    overflow-y: auto;  /* 将原来的 overflow: hidden 改为 auto */
    -webkit-overflow-scrolling: touch;  /* 新增：iOS平滑滚动 */
    flex: 1; // 改为 flex: 1 而不是固定高度
    display: flex; // 添加 flex 显示
    flex-direction: column; // 纵向排列
    background-color: #F4F6FA;
  }
  .main-content.has-tabbar {
    padding-bottom: calc(5rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(5rem + env(safe-area-inset-bottom));
  }
  .main-content.no-tabbar {
    padding-bottom: 0rem;
  }
  .van-tabbar  {
    z-index: 2000;
    height: 5rem;
    position: fixed !important;
    left: 0;
    bottom: 0;
    .van-tabbar-item{
      flex-direction: row;
      position: relative;
      :deep(.van-tabbar-item__text) {
        font-size: 1.4rem;
        color: #9C9C9C;
        margin-left: .8rem;
      }
      :deep(.van-tabbar-item__icon) {
        position: relative;
        >img{
          width: 2.6rem;
          height: 2.6rem;
        }
      }
    }
    :deep(.van-tabbar-item:first-child)::after {
      content: '';
      position: absolute; /* 绝对定位 */
      right: 0; /* 靠右 */
      top: 50%; /* 垂直方向从50%处开始 */
      width: 1px; /* 线宽 */
      height: 50%; /* 高度50% */
      background-color: #778097; /* 线的颜色 */
      transform: translateY(-50%); /* 向上移动自身50%，实现垂直居中 */
    }
    .van-tabbar-item--active {
      :deep(.van-tabbar-item__text) {
        color: #3A3A3A ;
      }
    }
  }
  .tabbar-icon {
    width: 2.8rem;
    height: 2.8rem;
    display: block;
  }
  .hidden-img {
    width: 2.8rem;
    height: 2.8rem;
    display: none;
  }
  </style>
